import { useEffect } from "react";
import { getCurrencyAmount } from "../../../utils/stringUtils";

import Toaster from "./../../../components/common/Toaster";

import journalService from "../../../services/journalService";
import moment from "moment";
import _ from "lodash";

const JournalTable = ({
  id,
  refresh,
  data,
  setData,
  isLoading,
  setLoading,
}) => {
  const columns = [
    { path: "transaction_date", label: "Date" },
    { path: "transaction_number", label: "No." },
    { path: "account_chart", label: "Account" },
    { path: "description", label: "Description" },
    { path: "name", label: "Name" },
    { path: "debit", label: "Debit" },
    { path: "credit", label: "Credit" },
  ];

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await journalService.getAccountJournalEntriesAsync(id);
        const { result } = response;

        const items = result.map((item) => {
          item["transaction_date"] = moment(item.transaction_date).format(
            "DD-MMM-yyyy"
          );

          item["debit"] = item.debit ? getCurrencyAmount(item.debit) : null;
          item["credit"] = item.credit ? getCurrencyAmount(item.credit) : null;

          return item;
        });

        if (mounted) {
          setData(items);
          setLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [id, refresh, setData, setLoading]);

  const renderCell = (item, column) => {
    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  const createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };

  return (
    <div className="overflow-auto mt-10">
      <table className="min-w-full table-fixed">
        <thead className="bg-gray-100">
          <tr>
            {columns.map((item, index) => (
              <th
                key={index}
                className={`p-3 text-left first:rounded-l-lg last:rounded-r-lg text-gray-600 text-sm`}
              >
                {item.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading && (
            <tr className="bg-gray-50">
              <td
                className="p-4 px-6 whitespace-nowrap text-gray-500 text-sm text-center"
                colSpan={columns.length}
              >
                Loading...
              </td>
            </tr>
          )}
          {!isLoading && data.length === 0 && (
            <tr className="bg-gray-50">
              <td
                className="p-4 px-6 whitespace-nowrap text-gray-500 text-sm text-center"
                colSpan={columns.length}
              >
                No data available
              </td>
            </tr>
          )}
          {!isLoading &&
            data.length > 0 &&
            data.map((item, key) => (
              <tr key={key}>
                {columns.map((column) => (
                  <td
                    key={createKey(item, column)}
                    className="p-3 whitespace-nowrap text-gray-500 text-sm text-left"
                  >
                    {renderCell(item, column)}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default JournalTable;
